// constants.js

/**
 * STATUS CONSTANTS
 * Replaces: export enum ReportStatus
 */
export const ReportStatus = {
  PENDING_RESPONSE: 'PENDING_RESPONSE',     // Grace period, not public
  PUBLISHED_UNRESOLVED: 'PUBLISHED_UNRESOLVED', // Public, no borrower response
  PUBLISHED_DISPUTED: 'PUBLISHED_DISPUTED',   // Public, borrower disputed
  PUBLISHED_SETTLED: 'PUBLISHED_SETTLED',    // Public, marked as paid
  WITHDRAWN: 'WITHDRAWN',            // Removed by lender
};

/**
 * RESPONSE TYPE CONSTANTS
 * Replaces: export enum BorrowerResponseType
 */
export const BorrowerResponseType = {
  DISPUTE: 'DISPUTE',
  SETTLEMENT_OFFER: 'SETTLEMENT_OFFER',
  CLAIM_PAID: 'CLAIM_PAID',
};

/**
 * USER ROLES
 * Replaces: export type UserRole
 */
export const UserRole = {
  LENDER: 'LENDER',
  BORROWER: 'BORROWER',
};

// =============================================================================
// JSDOC DEFINITIONS (Optional)
// These do not affect runtime, but give you IntelliSense in VS Code
// =============================================================================

/**
 * @typedef {Object} EvidenceItem
 * @property {string} id
 * @property {string} name
 * @property {string} type
 * @property {string} data - Base64 string
 */

/**
 * @typedef {Object} BorrowerProfile
 * @property {string} name
 * @property {string} mobile
 * @property {string?} email
 */

/**
 * @typedef {Object} CreditReport
 * @property {string} id
 * @property {string} lenderId
 * @property {string} lenderName
 * @property {string} borrowerName
 * @property {string} borrowerMobile
 * @property {string} [borrowerEmail]
 * @property {BorrowerProfile[]} [additionalBorrowers]
 * @property {number} amount
 * @property {string} agreementDate
 * @property {string} dueDate
 * @property {string} description
 * @property {string} [lenderReply]
 * @property {string} [lenderReplyDate]
 * @property {string} status - One of ReportStatus values
 * @property {string} [borrowerResponse]
 * @property {string} [borrowerResponseType] - One of BorrowerResponseType values
 * @property {string} [borrowerResponseDate]
 * @property {EvidenceItem[]} [borrowerEvidenceAttachments]
 * @property {string} createdDate
 * @property {boolean} evidenceProvided
 * @property {EvidenceItem[]} [evidenceAttachments]
 */

/**
 * @typedef {Object} UserProfile
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {string} mobile
 * @property {string[]} roles - Array of UserRole values
 * @property {boolean} [isVerified]
 * @property {string} [verificationDate]
 */

export const INITIAL_REPORT_STATE = {
  id: '',
  lenderId: '',
  lenderName: '',
  borrowerName: '',
  borrowerMobile: '',
  amount: 0,
  description: '',
  status: ReportStatus.PENDING_RESPONSE,
  evidenceProvided: false,
  createdDate: new Date().toISOString(),
};